import {Fancybox} from "@fancyapps/ui";
import Swiper, {Navigation, Pagination, Thumbs} from 'swiper';
import StarRating from "star-rating.js";
import events from "./base";
import {notice} from "./Components/UI/notice";
import {formDataFBuilder, parseHTML} from "./Components/Core/common";

Swiper.use([Navigation, Thumbs, Pagination]);

import Choices from 'choices.js';

require('./base');

if (document.querySelector('.js_open_modal_add_comment')) {
    const comments = async () => await import("./Components/Comments/comment");
    comments().then(t => t.init(events));
}

let commentForm = document.querySelector('form[name="reviews-form"]');
if (commentForm) {
    const comments = async () => await import("./Components/Comments/comment");
    comments().then(t => t.initInline(commentForm));
}

const js_article_block = document.querySelector('.js_article_block');
if (js_article_block) {
    const js_anchors_block = document.querySelector('.js_anchors');
    if (js_anchors_block) {
        const js_anchors_div = js_anchors_block;
        if (js_anchors_div) {
            let titles = js_article_block.querySelectorAll('h2, h3, h4');

            titles.forEach((item, i) => {
                item.id = `anchor-${i}`;
                let anchor = parseHTML(`
                                                <a class="fw-sb fs-14 fs-sm-16" 
                                                    href="#anchor-${i}" 
                                                    title="Перейти к ${item.innerText}"
                                                >
                                                    ${item.innerText}
                                                </a>`);
                js_anchors_div.append(anchor);
            });

            if (titles.length > 1) {
                js_anchors_block.classList.remove('d-none');
            }
        }
    }
}

const _scrollTo = (block, yOffset) => {
    const y = block.getBoundingClientRect().top + window.pageYOffset + (yOffset || 0);
    window.scrollTo({top: y, behavior: 'smooth'});
};

document.querySelectorAll('a[href*="#"]').forEach(item => item.addEventListener('click', e => {
    if (item.pathname !== '/certificates.html') {
        e.preventDefault();
        const block = document.querySelector(item.getAttribute('href'));
        if (block) {
            _scrollTo(block, -document.querySelector('header').scrollHeight);
            block.click();
        }
    }
}));

window.noty = notice;

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.baner-slider').forEach(item => {
        let currentNavigation = document.querySelectorAll(`.baner-slider-navigation`);
        let navigation = {};
        let pagination = {};
        if (currentNavigation) {
            let next = '.baner-slider-navigation .slider-next';
            let prev = '.baner-slider-navigation .slider-prev';
            navigation = {
                nextEl: next,
                prevEl: prev,
            },
                pagination = {
                    el: '.baner-slider-navigation .slider-pagination',
                    type: 'fraction',
                };
        }
        new Swiper(item, {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: navigation,
            pagination: pagination,
            slideActiveClass: "active",
        });
    })
    document.querySelectorAll('.slider-5').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation__5[data-category="${currentCategory}"]`);
        let navigation = {};
        let pagination = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            },
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets',
                    dynamicBullets: true,
                    dynamicMainBullets: 1,
                };
        }
        if (item.querySelectorAll('.swiper-slide').length < 7) {
            currentNavigation.querySelector('.slider-pagination').classList.add('justify-content-center');
        }
        new Swiper(item, {
            modules: [Navigation, Pagination],
            spaceBetween: 8,
            slidesPerView: 'auto',
            navigation: navigation,
            pagination: pagination,
            slideActiveClass: "active",
            breakpoints: {
                1250: {
                    spaceBetween: 16,
                    slidesPerView: 5,
                }
            }
        });
    })
    document.querySelectorAll('.slider-3').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation__3[data-category="${currentCategory}"]`);
        let navigation = {};
        let pagination = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            },
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets',
                    dynamicBullets: true,
                    dynamicMainBullets: 1,
                };
        }
        if (item.querySelectorAll('.swiper-slide').length < 5) {
            currentNavigation.querySelector('.slider-pagination').classList.add('justify-content-center');
        }
        new Swiper(item, {
            modules: [Navigation, Pagination],
            spaceBetween: 8,
            slidesPerView: 'auto',
            navigation: navigation,
            pagination: pagination,
            slideActiveClass: "active",
            breakpoints: {
                1250: {
                    spaceBetween: 32,
                    slidesPerView: 2,
                },
                1480: {
                    spaceBetween: 32,
                    slidesPerView: 3,
                },
                1744: {
                    spaceBetween: 64,
                    slidesPerView: 3,
                }
            }
        });
    })
    document.querySelectorAll('.slider-product').forEach(productSlider => {
        let swiperProductThumbs = new Swiper('.slider-product__thumbs', {
            slidesPerView: 4,
            spaceBetween: 16,
            direction: 'horizontal',
            watchSlidesProgress: true,
            breakpoints: {
                992: {
                    slidesPerView: 6,
                    direction: 'vertical',
                }
            }
        });
        const swiperDefOpt = {
            spaceBetween: 8,
            slidesPerView: 'auto',
            direction: 'horizontal',
            breakpoints: {
                1250: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    direction: 'vertical',
                },
            }
        }
        const swiperProductOpt = {
            modules: [Thumbs, Navigation],
            thumbs: {
                swiper: swiperProductThumbs
            },
            navigation: {
                nextEl: document.querySelector('.slider-product__next'),
                prevEl: document.querySelector('.slider-product__prev'),
            }

        }
        if (document.querySelector('.slider-product__thumbs')) {
            new Swiper(productSlider, Object.assign({}, swiperDefOpt, swiperProductOpt));
        } else {
            new Swiper(productSlider, Object.assign({}, swiperDefOpt));
        }
    })
})

if (document.querySelector('[name="filter_category"]')) {
    let customSelect = async () => await import('./Components/filter');
    customSelect().then(e => e.init());
}

if (document.querySelector('.catalog-tabs, .product-cities, .cart-tabs')) {
    let tabs = async () => await import('./Components/tabs');
    tabs().then(e => e.init(".catalog-tabs, .product-cities, .cart-tabs"));
}


async function printJSON() {
    const response = await fetch("/api/v1/company/contacts");
    return await response.json();
}

if (document.querySelector('#map') || document.querySelector('.js_map_cities')) {

    printJSON().then(contactMap => {
        let getYamap = async () => await import('./Ymaps');

        getYamap().then(e => e.load().then(ymaps => {
                if (document.querySelector('.points-map')) {
                    //создание карты
                    const myMap = new ymaps.Map("points-map", {
                        center: [53.790278, 45.077990], zoom: 8,

                    });
                    const controls = ['geolocationControl', 'searchControl', 'trafficControl', 'typeSelector', 'fullscreenControl', 'rulerControl']
                    controls.forEach(item => {
                        myMap.controls.remove(item);
                    })
                    myMap.behaviors.disable('scrollZoom')
                    //Добавление точек из адресов на странице
                    let points = new Map;
                    contactMap.forEach(item => {
                        let category = item.category;
                        let placemark = new ymaps.Placemark([item.latitude, item.longitude], {
                            balloonContentHeader: `${item.title}`, balloonContentBody: `${item.address}`
                        }, {preset: 'islands#greenIcon'})
                        points.set(category, placemark)
                    });

                    //Добавление точек на карту
                    let myClusterer = new ymaps.Clusterer({preset: 'islands#violetClusterIcons'});

                    for (let point of points.values()) {
                        myClusterer.add(point);
                    }

                    myMap.geoObjects.add(myClusterer);

                    document.querySelectorAll('.js_map_cities').forEach(item => {
                        item.addEventListener('click', function () {
                            document.querySelectorAll('.js_map_cities').forEach(item => item.classList.remove('active'));
                            if (window.outerWidth < 992) {
                                document.querySelector('.points-map').scrollIntoView({
                                    block: "start", behavior: "smooth"
                                });
                            }
                            item.classList.add('active');
                            myMap.setCenter([+item.dataset.latitude, +item.dataset.longitude], 11, {
                                checkZoomRange: true, duration: 500, timingFunction: 'ease'
                            });
                        })
                    })
                }
            }).catch(error => console.log('Failed to load Yandex Maps', error)));
    });
}


document.querySelectorAll('.star-rating').forEach(item => {
    new StarRating(item, {
        clearable: true, tooltip: false, maxStars: 5,
    });
});


import {GET2URL, URL2GET} from './Components/Url';
import {modal} from "./Components/UI/modal";
import Agent from "./Components/Core/agent";
import config from "./Config/config";


document.querySelectorAll('.js_where, .js_order').forEach(item => item.addEventListener('change', () => {
    let preparedParams = {};
    let deletedParams = [];
    let currentQuery = URL2GET();

    if (item.name === 'available') {
        if (item.checked) {
            preparedParams.filter = 'available';
        } else {
            deletedParams.push('filter');
        }
    }

    if (item.name === 'order') {
        preparedParams.order = item.value;
    }

    let page = currentQuery.page || undefined;
    if (page !== undefined) {
        deletedParams.push('page');
    }
    document.location = (document.location.pathname + GET2URL(preparedParams, deletedParams));
}));


document.querySelectorAll('.js_next_page').forEach(item => item.addEventListener('click', () => {
    item.parentNode.classList.add('preloader');
    Agent.post('/api/next' + item.dataset.next).then(e => e.json()).then(e => {
        if (e.success) {
            if (e.products.length) {
                document.querySelector('.js_filter_result').append(parseHTML(e.products))
                events.dispatch('filter.search');
            }
            if (e.paginator.length) {
                document.querySelector('.js_filter2_paginate').innerHTML = e.paginator;
            }

            if (e.next_url) {
                item.dataset.next = e.next_url;
            } else {
                item.classList.add('d-none')
            }
        }
    }).finally(() => item.parentNode.classList.remove('preloader'));
}));


document.querySelectorAll('.js_order_filter').forEach(item => item.addEventListener('click', evt => {
    evt.preventDefault();
    evt.stopPropagation();

    document.querySelectorAll('.js_order_filter').forEach(order_filter => {
        if (item !== order_filter) {
            order_filter.classList.remove('active');
        } else {
            order_filter.classList.add('active');
        }
    });

    let id = +item.dataset.id;

    document.querySelectorAll('.js_order_status').forEach(order => {
        let orderId = +order.dataset.id
        if (!id || id === orderId) {
            order.closest('.js_order_item').classList.remove('d-none');
        } else {
            order.closest('.js_order_item').classList.add('d-none');
        }
    });
}));

if (document.querySelector('.category-show')) {
    let block = document.querySelector('.category-show');
    let btns = document.querySelectorAll('.btn-show');
    let items = block.querySelectorAll('.product-item');
    btns.forEach(item => {
        item.addEventListener('click', () => {
            btns.forEach(item => item.classList.remove('active'));
            item.classList.add('active');
            if (item.classList.contains('inline-show')) {
                block.classList.remove('grid-block');
                block.classList.add('inline-block');
                items.forEach(item => item.classList.add('inline-block'));
            } else {
                block.classList.add('grid-block');
                block.classList.remove('inline-block');
                items.forEach(item => item.classList.remove('inline-block'));
            }
        });
        if (item.classList.contains('grid-show')) {
            item.classList.add('active');
        }
    });
}

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    const filter = document.querySelector('.category-filter');
    const wrapper = filter.querySelector('.category-wrapper');
    const closeBtn = filter.querySelector('.category-filter__close');
    const body = document.querySelector('body');

    document.addEventListener('click', (e) => {
        if (filter.classList.contains('active')) {
            if (e.target == filter) {
                filter.classList.remove('active');
                body.classList.remove('mm-ocd-opened');
            }
        }
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            filter.classList.remove('active');
            body.classList.remove('mm-ocd-opened');
        })
    }
    if (btn) {
        btn.addEventListener('click', () => {
            filter.classList.add('active');
            body.classList.add('mm-ocd-opened');
        });
    }

    const eventClickButton = () => {
        const js_filter2_button = document.querySelector('.js_filter2_button');
        if (js_filter2_button) {
            js_filter2_button.dispatchEvent(new Event('click'));
            hideButton();
        }
    };


    let parameters = filter.querySelectorAll('label input');
    let button = document.createElement('button');
    button.classList.add('category-filter__float-btn');
    button.setAttribute("data-label", 'Показать');
    button.type = 'button';

    let hideTimer = null;

    function hideButton() {
        button.remove();
        clearTimeout(hideTimer);
        hideTimer = null;
        button.removeEventListener('click', eventClickButton);
    }

    function showButton(item) {
        hideTimer ? clearTimeout(hideTimer) : wrapper.appendChild(button);
        hideTimer = setTimeout(hideButton.bind(this), 5000);
        let paramL = item.target.closest('label');
        let parent = paramL.closest('.category-wrapper');
        let parentT = parent.getBoundingClientRect().top;
        let ttest = paramL.getBoundingClientRect().top;
        let top

        top = (ttest - parentT) - ((button.clientHeight / 2) - (paramL.clientHeight / 2));
        button.style.top = top + 'px';
        button.addEventListener('click', eventClickButton);
    }

    parameters.forEach(param => {
        if (param.attributes.type.value === 'checkbox') {
            param.addEventListener('change', function (e) {

                showButton(e);
            })
        }
        if (param.attributes.type.value === 'number') {
            param.addEventListener('input', function (e) {
                showButton(e);
            })
        }
    })
}
document.querySelectorAll('.js-choice').forEach(choice => {
    new Choices(choice, {
        itemSelectText: '',
        position: 'bottom',
        searchEnabled: false,
        shouldSort: false,
    });
})


document.querySelectorAll('.js_show_category')
    .forEach(item => item.addEventListener('click', () => {
        item.classList.add('preloader');
        const id = +item.dataset.id;
        Agent.post(`/api/v1/category/${id}/products/`, JSON.stringify({id}), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(e => e.json())
            .then(e => {
                if (e.success) {
                    const obj = {
                        'message': `<span class="fs-24 fw-md">Добавьте к заказу</span><div class="modalc-additional__grid">${e.data.join("")}</div>`,
                        'size': 'modal-xl',
                        'header': function () {
                            return `<div class="modal-header">
                                   <button class="btn-close btn-inline href-main position-absolute d-flex bg-transparent" data-bs-dismiss="modal">
                                    <i class="icon close fs-24"></i>
                                </button>
                            </div>`;
                        }
                    }
                    modal(obj, function () {
                        events.dispatch('filter.search');
                    });
                } else {
                    notice('Товары для данной категории не найдены')
                }
            })
            .catch(e => console.log(e))
            .finally(() => {
                item.classList.remove('preloader');
            });
    }));

let filterListInputTimer;
document.querySelectorAll('input[name="filter-search"]').forEach(function (item) {
    item.addEventListener('input', function () {
        clearTimeout(filterListInputTimer);
        filterListInputTimer = setTimeout(function () {
            let filter = item.value.toUpperCase();
            let block = item.closest('.js_filter2_string_block');
            block.querySelectorAll('label span').forEach(function (l) {
                let is = l.innerHTML.toUpperCase().indexOf(filter) > -1;

                if (is) {
                    l.closest('label').classList.remove('d-none');
                } else {
                    l.closest('label').classList.add('d-none');
                }
            });
        }, 300);
    });
});

const Share = {
    vkontakte: (purl, ptitle) => {
        let url  = 'http://vkontakte.ru/share.php?';
        url += 'url='          + encodeURIComponent(purl);
        url += '&title='       + encodeURIComponent(ptitle);
        url += '&noparse=true';
        Share.popup(url);
    },
    odnoklassniki: (purl, ptitle) => {
        let url  = 'https://connect.ok.ru/offer';
        url += '?url='    + encodeURI(purl);
        url += '&title=' + encodeURI(ptitle);
        Share.popup(url);
    },
    facebook: (purl, ptitle)=> {
        let url  = 'http://www.facebook.com/sharer.php?s=100';
        url += '&p[title]='     + encodeURIComponent(ptitle);
        url += '&p[url]='       + encodeURIComponent(purl);
        Share.popup(url);
    },
    whatsapp: (purl, ptitle)=> {
        let url = 'https://wa.me/?';
        url += 'text='          + encodeURI(ptitle);
        url += ': '         + encodeURI(purl);
        Share.popup(url);
    },
    telegram: (purl, ptitle)=> {
        let url = 'https://t.me/share/url?';
        url += 'url='          + encodeURI(purl);
        url += '&text='       + encodeURI(ptitle);
        Share.popup(url);
    },

    popup: function(url) {
        window.open(url,'','toolbar=0,status=0,width=626,height=436');
    }
};

document.querySelectorAll('.js__pageLinkCopy').forEach(item => {
    item.addEventListener('click', async function() {
        try {
            // Копируем URL в буфер обмена
            await navigator.clipboard.writeText(window.location.href);
            notice('Адрес страницы скопирован')
        } catch (err) {
            console.error('Ошибка при копировании: ', err);
        }
    })
});

window.Share = Share;